/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
  Loader,
  Dimmer
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { MyInput, MyNormalInput, MyTextArea } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/read";
import ReadVAxios from "../axiosComponent/readV";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import * as yup from 'yup';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import moment from "moment";
import MyVendorComponent from "../dynamicComponent/vendorSearch";
import MyUnitOfMeasurement from "../apiInputs/myUnitOfMeasurement";
import { LOCAL_STORAGE, FEATURES } from '../../utils/constant'

const ModalAllot = ({ values, isSubmitting, touched, errors, handleSubmit, setFieldValue, t, order, role, ...props }) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [VendorData, setVendorData] = useState([]);
  const [vendorBranches, setVendorBranches] = useState([])
  const [evaluateErrors, setEvaluateErrors] = useState({
    uom: false
  })
  const [Lr, setLr] = useState([]);
  console.log(values, 'valuessss')
  useEffect(() => {
    getAllVendors();
  }, []);
  let handleOpen = () => setmodalOpen(true);
  let handleClose = () => {
    setmodalOpen(false);
  };
  // let handleSubmited = () => {
  //   setmodalOpen(false);
  //   if (values.vendor) handleSubmit();
  // };

  const getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
      })
      .catch((err) => setVendors([]));
  };
  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: `${item.transporterName} (${item.transporterCode})`,
        key: item.transporterCode,
        value: item.transporterMasterId,
      };
    });
    setVendors(result);
  };

  const getVendorData = (data) => {
    setFieldValue("vendor", data.value)
    ReadVAxios({ url: `vendorDetails/${data.value}` })
      .then((res) => {
        if (res.status == 200) {
          let vdata = res.data.resultSet
          // setVendorData(vdata, () => {
          //   console.log('checkvendor data', VendorData);
          // });
          let vendor_branches = vdata.branches.length > 0 ?
            vdata.branches.map((object, index) => {
              let temp = {}
              temp.key = object.vendorBranchId
              temp.text = object.vendorBranchName
              temp.value = object.vendorBranchId
              return temp
            }) : []

          setVendorBranches(vendor_branches);
          setFieldValue('vendorData', vdata);

        }
        createHireMemo(res.data.resultSet);
      })
      .catch((err) => {
        console.log(err);
      });

  };
  const evaluateFreightRate = () => {
    if (!values.uom) {
      setEvaluateErrors({ ...evaluateErrors, uom: true })
    } else {
      const payload = {
        movement_type: order?.shipment?.movement_type,
        required_on: order?.shipment?.required_on && new Date(order.shipment.required_on),
        billing_party_id: order?.deliveries.length > 0 ? order?.deliveries[0].billing_party_id : null,
        consignee_id: order?.deliveries.length > 0 ? order?.deliveries[0].consignee?.consigneeId : null,
        consignor_id: order?.deliveries.length > 0 ? order?.deliveries[0].consignor?.consignorId : null,
        load_type_id: order?.load_type_id,
        proposed_vehicle_type: order?.proposed_vehicle_type,
        route_id: order?.shipment?.route_id,
        budgeted_kms: order?.shipment?.budgeted_kms && Number(order.shipment.budgeted_kms),
        uom: values.uom,
        vendor_id: values.vendor,
        actual_charges: values.actual_hire_charge,
        gross_weight: order?.gross_weight,
        mode_of_transport : order?.mode_of_transport,
        total_no_of_boxes : order?.deliveries.length > 0 ? order?.deliveries[0].total_quantity : null,
      }
      ReadAxios({
        baseURL: `${process.env.REACT_APP_TA_API_URL}`,
        url: `orders/freight/rate/calculate`,
        readItems: payload
      }).then((res) => {
        if (res.data?.status === 1) {
          res.data?.data?.ps_line_item_charges && setFieldValue('ps_line_item_charges', res.data.data.ps_line_item_charges)
          res.data?.data?.final_freight_rate ? setFieldValue('freight_rate', res.data.data.final_freight_rate) : setFieldValue('freight_rate', 0)
          res.data?.data?.proposed_freight_rate ? setFieldValue('proposed_hire_charge', res.data.data.proposed_freight_rate) : setFieldValue('proposed_hire_charge', 0)
        }
      }).catch((err) => {
        console.log(err);
      })
    }
  }

  const createHireMemo = (data) => {
    // CreatAxios({
    //   completeURL: `${process.env.REACT_APP_TA_API_URL}/hm/create`,
    //   payload: { ...shipments, required_on },
    // })
    // .then((res) => {
    //   console.log(res);
    // })
    // .catch((err) => {
    //   console.log(err);
    // });
  }

  const customerNo = LOCAL_STORAGE.customerNo
  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="small"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            disabled={role == "Broker" ? true : false}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("title_button") || "Allot"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">{t("title") || "Allot Shipment"}</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <div className="ui form">
              <FormUi.Field
                width={12}>
                <label className="labelName mt-2 required-form-element">
                  {t(customerNo != 1158 ? "vendor.vendor_title" : "vendor.title") || "Select Vendor"}
                </label>
                <Dropdown
                  name="vendor"
                  clearable
                  search
                  style={{ width: "100%" }}
                  selection
                  placeholder={t(customerNo != 1158 ? "vendor.vendor_placeholder" : "vendor.placeholder") || "Select Vendor"}
                  onChange={(name, data) => getVendorData(data)}
                  options={Vendors}
                  defaultValue={values.vendor}
                />
              </FormUi.Field>
              <FormUi.Field
                width={12}>
                <label className="labelName mt-2">
                  {t(customerNo != 1158 ? "vendor_branch.vendor_title" : "vendor_branch.title") || "Partner Branch"}
                </label>
                <Dropdown
                  className="mr-1 checkselect"
                  name="vendor_branch_id"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  // disabled={disable}
                  selection
                  placeholder={
                    t(customerNo != 1158 ? "vendor_branch.vendor_placeholder" : "vendor_branch.placeholder") ||
                    "Partner Branch"
                  }
                  onChange={(name, data) => setFieldValue('vendor_branch_id', data.value)}
                  options={vendorBranches}
                />
              </FormUi.Field>
              {/* <Fieldmik name={"vendor"} defaultValue={values.vendor}  placeholder={t("vendor.placeholder") || "Select Vendor"} component={MyVendorComponent} /> */}

              {values.vendorData && values.vendorData?.vendorOwnershipType !== 1 &&
                <>
                  <FormUi.Field
                    width={12}
                    style={{ padding: "0 0 10px 0" }}
                  >
                    <label>{'Vendor Advance'}</label>
                    <div>
                      <Slider name="vendor_advance_payment" min={80} max={100} defaultValue={80} marks={{ 80: 80, 100: 100 }} onChange={(data) => { setFieldValue('vendor_advance_payment', data) }} handle={(data) => { }} />
                      <div className="margin-left-40-cent">{values.vendor_advance_payment} %</div>
                    </div>
                    {touched.vendor_advance_payment && errors.vendor_advance_payment ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.remarks}</strong> : ''}
                  </FormUi.Field>

                </>}


              {order && order.shipment.movement_type != "Primary" ? (
                <>
                  <FormUi.Field
                    width={12}
                    style={{ padding: "0 0 10px 0" }}
                  >
                    <label>{t("container_seal_no") || "Container Seal No"}</label>
                    <Fieldmik
                      placeholder={values.container_seal_no}
                      component={MyNormalInput}
                      name="container_seal_no"
                    />
                  </FormUi.Field>
                </>
              ) : (
                null
              )}


              {values.vendorData && values.vendorData?.vendorOwnershipType !== 1 &&
                <>
                  <FormUi.Group>
                    <FormUi.Field
                      width={12}>
                      <div className="row">
                        <h3 className="sub-heading-adjust ml-2">
                          <>{t("freight_details.title") || "Freight Details"}</>
                        </h3>
                        {/* <Button
                                        basic
                                        color="green"
                                        type="button"
                                        size="mini"
                                        icon
                                        className="ml-auto m-2"
                                        onClick={evaluateFreightRate}
                                      >
                                        {t("freight_details.evaluate_btn")||"Evaluate Freight"}
                                      </Button> */}
                      </div>
                    </FormUi.Field>
                  </FormUi.Group>

                  <FormUi.Group>
                    <FormUi.Field
                      width={5}
                    >
                      <label>{t("freight_details.uom.title") || "UOM"}</label>
                      <Fieldmik
                        placeholder={t("freight_details.uom.placeholder") || "Unit Of Measurement"}
                        component={MyUnitOfMeasurement}
                        name="uom"
                        value={values.uom}
                        uom_name={values.uom_name}
                        onChangeExtra={() => setEvaluateErrors({ ...evaluateErrors, uom: false })}
                        style={{ width: '90%' }}
                      />
                      {evaluateErrors.uom && <small className="text-danger">Required to calculate freight amount.</small>}
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                    <FormUi.Field
                      width={4}
                      className="mt-3"
                    >
                      <Button
                        basic
                        color="green"
                        type="button"
                        size="mini"
                        icon
                        className="ml-auto m-2"
                        onClick={evaluateFreightRate}
                      >
                        {t("freight_details.evaluate_btn") || "Evaluate Freight"}
                      </Button>
                    </FormUi.Field>
                    <FormUi.Field width={8} />
                  </FormUi.Group>

                  <FormUi.Group>
                    <FormUi.Field
                      width={5}
                    >
                      <label>{t("freight_details.propsed_charge") || "Proposed Hire Charge"}</label>
                      <Fieldmik
                        type="number"
                        component={MyNormalInput}
                        name="proposed_hire_charge"
                        readOnly={true}
                      />
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                    <FormUi.Field
                      width={5}
                    >
                      <label>{t("freight_details.actual_charge") || "Actual Hire Charge"}</label>
                      <Fieldmik
                        type="number"
                        component={MyNormalInput}
                        name="actual_hire_charge"
                      />
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                    <FormUi.Field
                      width={5}
                    >
                      <label>{t("freight_details.final_rate") || "Final Rate"}</label>
                      <Fieldmik
                        type="number"
                        component={MyNormalInput}
                        name="freight_rate"
                      />
                    </FormUi.Field>

                  </FormUi.Group>

                  <FormUi.Group>
                    {/* <FormUi.Field
                    width={5}
                    style={{ padding: "0 0 10px 0" }}
                  >
                    <label>{t("freight_details.uom.title")||"UOM"}</label>
                    <Fieldmik
                      placeholder={t("freight_details.uom.placeholder")||"Unit Of Measurement"}
                      component={MyUnitOfMeasurement}
                      name="uom"
                      value={values.uom}
                      uom_name={values.uom_name}
                      onChangeExtra={()=>setEvaluateErrors({...evaluateErrors, uom:false})}
                    />
                    {evaluateErrors.uom && <small className="text-danger">Required to calculate freight amount.</small>}
                  </FormUi.Field>
                  <FormUi.Field width={2} /> */}
                    {/* <FormUi.Field
                    width={5}
                    style={{ padding: "0 0 10px 0" }}
                  >
                    <label>{t("freight_details.final_rate")||"Final Rate"}</label>
                    <Fieldmik
                      type="number"
                      component={MyNormalInput}
                      name="freight_rate"
                    />
                  </FormUi.Field> */}
                  </FormUi.Group>
                </>
              }

                {props?.permissions?.TA_SHIPMENT?.UPDATE ? (
                <>
                  <FormUi.Field
                    style={{ padding: "0 0 10px 0" }}
                    className={values.vendorData && values.vendorData.vendorOwnershipType !== 1 ? "" : "width75"}
                  >
                    <label className={FEATURES.remarksRequired_vendorAllotModal ? "required-form-element" : ""}>{t("remarks") || "Remarks"}</label>
                    <Fieldmik
                      placeholder={values.remarks}
                      component={MyTextArea}
                      name="remarks"
                    />
                    {touched.remarks && errors.remarks ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.remarks}</strong> : ''}
                  </FormUi.Field>

                </>
              ) : (
                null
              )}

            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          {FEATURES.remarksRequired_vendorAllotModal ?
            <Button
              type="submit"
              onClick={handleSubmit}
              disabled={isSubmitting || (values.remarks && values.vendor) ? false : true}
              size="mini"
              className="w3-blue w3-round w3-hover-blue"
            >
              {t("action_button.submit") || "Submit"}
            </Button>
            :
            <Button
              type="submit"
              onClick={handleSubmit}
              disabled={values.vendor ? isSubmitting ? true : false : true}
              size="mini"
              className="w3-blue w3-round w3-hover-blue"
            >

              {
                isSubmitting ?
                  <>
                    <Dimmer active inverted style={{
                      position: 'relative',
                      backgroundColor: '#1897ff',
                    }}>
                      <Loader size='small' />
                    </Dimmer>
                  </> :
                  <>
                    {t("action_button.submit") || "Submit"}
                  </>
              }
            </Button>
          }
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikModalAllot = withFormik({
  mapPropsToValues(props) {
    return {
      vendor: "",
      freight_rate: 0,
      vendor_branch_id: "",
      remarks: "",
      vendor_advance_payment: 80,
      container_seal_no: "",
      customer: LOCAL_STORAGE.customerNo,
      proposed_hire_charge: 0,
      uom: "",
      uom_name: props?.order?.deliveries.length > 0 ? props?.order?.deliveries[0].uom : null,
      actual_hire_charge: 0,
      freight_rate: 0,
      vendorData: '',
      ps_line_item_charges: []
    };
  },

  validationSchema: yup.object({
    customer: yup.mixed(),
    remarks: yup.mixed().when('customer', {
      is: (customer) => {
        return customer && (customer == 1165 || customer == 1166) ? true : false
      },
      then: yup.string().required('Remarks is Mandatory'),
      otherwise: yup.string().optional()
    }),
  }),

  // yup.mixed().when(['customer'], (customer, schema) => {
  //   return customer ? schema.test("customer", "Remarks is mandatory.", (value) => {
  //       console.log("Customer =====>", value)
  //       return value && value === 1165
  //   }) 
  //   : 
  //   schema
  //   })
  async handleSubmit(values, { setSubmitting, props }) {
    let no = LOCAL_STORAGE.customerNo
    if(props.onSubmitFirst){
      await props.onSubmitFirst()
    }
    if (!values.actual_hire_charge) {
      values.actual_hire_charge = values.proposed_hire_charge
    }
    // if (no == 1122 || no == 1123) {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.order.vendor_order_id}/allocate/vendor/${values.vendor}`,
      payload: { ...values }
    })
      .then((res) => {
        setSubmitting(false);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        props.reFetchOrder();
        // window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err?.response?.data?.message ? err.response.data.message : err.message,
        });
      });
    //   } else {
    //         let testlr = [];
    //   let billData = {"hire_memo_id": "", "hire_memo_no": "", "purchase_order_no": "", "purchase_order_id": ""}
    //   props.order.deliveries.map((del, index) => {
    //     console.log('in map', del.transporter_lr_no);
    //     testlr.push(del.delivery_no)
    //   })
    //   console.log('in map off', testlr);
    // let hirememodata = {
    //   "hireMemoDate":moment(new Date()).format("YYYY-MM-DD"),
    //   "lrNo": testlr,
    //   "vendorCode":values.vendorData[0].transporterCode,
    //   "vehicleNo":"",
    //   "vehicleType":"",
    //   "fromCity":"",
    //   "toCity":"",
    //   "branchCode":"",
    //   "hireCharge":+values.freight_rate,
    //   "tdsCharge":0,
    //   "advanceGiven":0,
    //   "remarks":"",
    //   "accountName":"",
    //   "accountNo":0,
    //   "ifscCode":"",
    //   }
    //   console.log(hirememodata);
    //   CreateAxios({
    //     completeURL: `${process.env.REACT_APP_BASE_COMMON}/hm/create`,
    //     payload: { ...hirememodata },
    //   })
    //   .then((res) => {
    //     console.log(res);
    //     props.successAlertDispatcher({
    //       type: "success",
    //       messageHeader: "Success",
    //       messageBody: res.data.message,
    //     });
    //     billData.hire_memo_id = res.data.data.id;
    //     billData.hire_memo_no = res.data.data.hireMemoNo;
    //     if (res.data.status == true) {
    //       let po = {
    //         "poReferenceNo": res.data.data.hireMemoNo,
    //         "vendorCode": values.vendorData[0].transporterCode,
    //         "branchCode": "",
    //         "vendorBranchCode": "",
    //         "vehicleNo": "",
    //         "poQuantity": 1,
    //         "poAmount": values.freight_rate,
    //         "sgstAmount": "",
    //         "cgstAmount": "",
    //         "igstAmount": "0.00",
    //         "adjustment": "0.00",
    //         "totalOrderAmt": values.freight_rate,
    //         "remarks": "",
    //         "gstTaxType": 0,
    //         "poDate": moment(new Date()).format("YYYY-MM-DD"),
    //         "tdsAmount": "0.00",
    //         "taxableAmount": values.freight_rate,
    //         "totalDiscount": "0.00",
    //         "psDetails": [
    //           {
    //             "psCode": "PS00006",
    //             "psName": "",
    //             "psQty": 1,
    //             "psPrice": values.freight_rate,
    //             "psAmount": values.freight_rate,
    //             "totalAmount": values.freight_rate,
    //             "igstPercent": 0,
    //             "igstAmount": "",
    //             "cgstPercent": 0,
    //             "cgstAmount": "",
    //             "sgstPercent": 0,
    //             "sgstAmount": "",
    //             "tdsCode": "",
    //             "tdsAmount": "",
    //             "startDate": "",
    //             "endDate": "",
    //             "discount": 0,
    //             "finalDiscount": 0,
    //             "discountType": 0,
    //             "taxableAmount": values.freight_rate,
    //           }
    //         ]
    //       }
    //       CreateAxios({
    //         completeURL: `${process.env.REACT_APP_BASE_COMMON}/purchase/purchaseorder/create`,
    //         payload: { ...po },
    //       })
    //       .then((res) => {
    //         billData.purchase_order_no = res.data.data[0].poReferenceNo;
    //         billData.purchase_order_id = res.data.data[0].poId;
    //         props.successAlertDispatcher({
    //           type: "success",
    //           messageHeader: "Success",
    //           messageBody: res.data.message,
    //         });
    //         if (res.data.status == 1) {
    //           console.log('bill',billData );
    //         CreateAxios({
    //           completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.order.vendor_order_id}/allocate/vendor/${values.vendor}`,
    //           payload: { ...values, ...billData}
    //         })
    //           .then((res) => {
    //             setSubmitting(false);
    //             props.successAlertDispatcher({
    //               type: "success",
    //               messageHeader: "Success",
    //               messageBody: res.data.message,
    //             });
    //             props.reFetchOrder();
    //             window.location.reload();
    //           })
    //           .catch((err) => {
    //             console.log(err);
    //             props.successAlertDispatcher({
    //               type: "error",
    //               messageHeader: "Error",
    //               messageBody: err.message,
    //             });
    //           });   
    //         }
    //       })
    //       .catch((err) => {
    //         console.log(err.response);
    //         props.errorAlertDispatcher({
    //           type: "error",
    //           messageHeader: "Error",
    //           messageBody: err.response.data.err.message,
    //         });
    //       });
    //     }

    //   })
    //   .catch((err) => {
    //     console.log('err',err.response);
    //     if (err.response.status == 500) {
    //       console.log(err.response);
    //     } else {
    //       console.log(err.response);
    //     }
    //     // props.errorAlertDispatcher({
    //     //   type: "error",
    //     //   messageHeader: "Error",
    //     //   messageBody: err.response.data.err.message,
    //     // });
    //   });
    //   }


  },
})(ModalAllot);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikModalAllot)
);
